import { gql, useQuery } from "@apollo/client";

const GetTeacherCoordinatorReviewHistoryQuery = gql`
  query getTeacherCoordinatorReviewHistory($teacherId: String!) {
    getTeacherCoordinatorReviewHistory(teacherId: $teacherId) {
      id
      teacherId
      reviewedAtUtc
      scores {
        fluencyScore
        presenceScore
        clarityScore
      }
    }
  }
`;

export type TeacherCoordinatorReviewHistoryItem = {
  id: string;
  teacherId: string;
  reviewedAtUtc: string;
  scores: {
    fluencyScore: number;
    presenceScore: number;
    clarityScore: number;
  };
};

export function useTeacherCoordinatorReviewHistory(teacherId: string) {
  const { data, loading, refetch } = useQuery(
    GetTeacherCoordinatorReviewHistoryQuery,
    {
      variables: { teacherId },
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    history: (data?.getTeacherCoordinatorReviewHistory ??
      []) as TeacherCoordinatorReviewHistoryItem[],
    loading,
    refetch,
  };
}
